<template>
  <div class="title" :style="{ color: color === 'black' ? '#3d3d3d' : '#ffffff' }">
    <span>{{ title }}</span>
    <span v-if="amount" class="amount" :style="{ color: color === 'black' ? '#666666' : '#ffffff' }">{{ `（总计：￥${amount}）` }}</span>
    <el-popover v-if="popover" placement="bottom" :width="width" trigger="hover">
      <div slot="reference">
        <img
          :src="color === 'black' ? require('../../assets/image/report_tips_icon.png') : require('../../assets/image/report_tips_icon_white.png')"
          alt=""
          :class="color === 'black' ? 'icon_1' : 'icon_2'"
          :style="{ marginLeft: amount ? '' : '4px' }"
        />
      </div>
      <div>{{ popover }}</div>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    amount: {
      type: [Number, String],
      default: 0,
    },
    width: {
      type: [Number, String],
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'black',
    },
    popover: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 16px;
  .amount {
    font-size: 14px;
  }
  .icon_1 {
    width: 16px;
    height: 16px;
    vertical-align: text-bottom;
  }
  .icon_2 {
    width: 14px;
    height: 14px;
    vertical-align: text-bottom;
  }
}
</style>
